import { Divider as MUIDivider } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function Divider() {
  return (
    <div className="w-full py-2">
      <MUIDivider sx={{ color: HNSColors.primary[900], borderBottomWidth: 2 }} />
    </div>
  );
}
